module.exports = __webpack_public_path__ + "static/media/YM33_3.1ff49188.jpg";